import { html } from 'lit-element';
import { unsafeHTML } from 'lit-html/directives/unsafe-html';
/* eslint-disable camelcase, no-invalid-this */

const updateState = function(event) {
  const { values = [] } = event.detail;
  this.setValues(values);
};

/**
 * Render: chips
 * @return {*}
 */
const render_chips = function() {
  const {
    options,
    required,
    menu,
    values,
    chipsType
  } = this;

  const parsedOptions = options.map(chip => {
    if (typeof chip === 'string') {
      return { value: chip, label: chip };
    }
    return chip;
  });

  return html`
    <fc-chips
      ?required="${required}"
      ?menu="${menu}"
      .values="${values}"
      .type="${chipsType}"
      @change=${updateState.bind(this)}>
      ${parsedOptions.length ? parsedOptions.map(chip => html`
        <fc-chip
          chip-id="${chip.value}"
          ?closeable="${menu}"
          style="
            --fc-chip-background: var(--fc-gray-200);
            --fc-chip-hover-background: var(--fc-gray-300);">
          ${unsafeHTML(chip.label)}
        </fc-chip>`) : null}
    </fc-chips>
  `;
};

export { render_chips };
